import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AudioQueueProvider } from './context/AudioQueueContext';

// Detect basename dynamically from current URL
const getBasename = (): string => {
  const path: string = window.location.pathname;
  if (path.startsWith('/audio-queue-demo')) {
    return '/audio-queue-demo';
  }
  return '';
};

const basename: string = getBasename();

const root: ReactDOM.Root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <BrowserRouter basename={basename}>
      <AudioQueueProvider>
        <App />
      </AudioQueueProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
